import { render, staticRenderFns } from "./ServiceIntegration.vue?vue&type=template&id=b4160eba&scoped=true&"
import script from "./ServiceIntegration.vue?vue&type=script&lang=ts&"
export * from "./ServiceIntegration.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceIntegration.vue?vue&type=style&index=0&id=b4160eba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4160eba",
  null
  
)

export default component.exports